'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rcProgress = require('rc-progress');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//eslint-disable-line

var ProgressIndicator = function ProgressIndicator(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_rcProgress.Line, props)
  );
};

ProgressIndicator.defaultProps = {
  percent: '0',
  strokeColor: '#221B43',
  trailColor: '#EEEEEE',
  strokeWidth: '4',
  trailWidth: '4'
};

exports.default = ProgressIndicator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/components/ProgressIndicator/index.js
// module id = 1093
// module chunks = 29